import * as React from 'react';
import useAsyncAction from '../../commonComponents/Hooks';
import { removeRefreshToken } from '../../core/api';
import config from '../../config.general';
import logOut from '../../core/session';

// Attribution: https://dev.to/olumidesamuel_/implementing-autologout-feature-in-web-applications-react-js-28k5
const AppLogout = (props: Props) => {
	let timer: NodeJS.Timeout;
	const performAsyncAction = useAsyncAction();

	// this function sets the timer that logs out the user after 30 minutes
	const handleLogoutTimer = () => {
		timer = setTimeout(() => {
			// clears any pending timer.
			resetTimer();
			// Listener clean up. Removes the existing event listener from the window
			Object.values(events).forEach((item) => {
				window.removeEventListener(item, resetTimer);
			});
			// logs out user
			handleLogout();
		}, config.autoLogoutTimeoutInMs);
	};

	// this resets the timer if it exists.
	const resetTimer = () => {
		if (timer) clearTimeout(timer);
	};

	// when component mounts, it adds an event listeners to the window
	// each time any of the event is triggered, i.e on mouse move, click, scroll, keypress etc, the timer to logout user after time X of inactivity resets.
	// However, if none of the event is triggered within time X, that is app is inactive, the app automatically logs out.
	React.useEffect(() => {
		Object.values(events).forEach((item) => {
			window.addEventListener(item, () => {
				resetTimer();
				handleLogoutTimer();
			});
		});
	}, []);

	// logs out user by clearing out auth token in localStorage and redirecting url to login page.
	// TODO: Consider using logOut function instead
	const handleLogout = async () => {
		await performAsyncAction(async () => {
			await removeRefreshToken();
			logOut();
		});
	};

	return props.children;
};

export default AppLogout;

interface Props {
	children: React.JSX.Element;
}

const events = [
	'load',
	'mousemove',
	'mousedown',
	'click',
	'scroll',
	'keypress',
	'touchstart',
	'touchmove',
	'touchend',
	'touchcancel'
];
